<template>
    <v-card class="campaignHeraldStat pa-3 pt-0" v-if="campData && !campData.code">
        <v-card-text>
            <v-tabs v-model="tabId">
                <v-tab v-for="(graphData, index) in allGraphData" :key="'tab_' + index" class="primary--text">
                    {{ $t(index) }}
                </v-tab>

                <v-tabs-items v-model="tabId" class="mt-8">
                    <v-tab-item v-for="(graphData, index) in allGraphData" :key="'tab_item_' + index">
                        <div v-if="graphData.datasets && graphData.labels.length">
                            <DonutComponent :dataSet="graphData" :legend="false" style="height: 200px;"/>

                            <v-simple-table class="mt-4" dense>
                                <template v-slot:default>
                                    <tbody>
                                        <tr v-for="(legend, index) in graphData.labels">
                                            <td><span :style="'width: 20px; height:20px; display:inline-block; background-color:' + graphData.datasets[0].backgroundColor[index]"></span></td>
                                            <td><b>{{ legend }}</b></td>
                                            <td class="text-right"><b class="mr-2">{{ graphData.datasets[0].data[index] }}</b><small>{{ (100 * graphData.datasets[0].data[index] / getDataTotal(graphData.datasets[0].data)).toFixed(2) }}%</small></td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                        <v-alert class="mb-0 mx-6" border="left" color="info" v-else text>
                            {{ $t("emptyDataMessage") }}
                        </v-alert>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card-text>
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';
import DonutComponent from '@/components/graphs/DonutComponent';

export default {
    name: "campaignHeralStat",
    props: ['campaign'],
    components:{ DonutComponent },
    data() {
        return {
            campData: {},
            tabId: 0,
            default_colors: [
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
            allGraphData: {  
                "MSG_DOMAINS": {},
                // "MSG_PLATFORMS": {},
                // "MSG_BROWSERS": {},
            },
        }
    },
    created() {
        if(!this.campData.total && this.$route.params.id) {
            GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getCampaignHeraldStats').then((response) => {
                this.campData = response.data.data;
                if(!this.campData.code)
                    this.generateGraphData();
            });
        }
    },
    mounted() {
        if(!this.campData.total && this.$route.params.id) {
            GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getCampaignHeraldStats').then((response) => {
                this.campData = response.data.data;
                if(!this.campData.code)
                    this.generateGraphData();
            });
        }
    },
    methods: {
        generateGraphData() {
            for (let property in this.allGraphData) {
                this.allGraphData[property] = {
                    "labels": Object.keys(this.campData[property]),
                    "datasets": [{
                        "data": Object.values(this.campData[property]),
                        "backgroundColor": this.default_colors.slice(0, Object.keys(this.campData[property]).length)
                    }]
                }
            }
        },
        getDataTotal(datas) {
            return datas.reduce((a, b) => a + b, 0);
        }
    },
}
</script>

<style lang="scss">
    .campaignHeraldStat {
        td:first-child { width: 25px ;}
    }
</style>